import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Email } from "@faire/web--source/slate/icons/foundation/Email";
import { Exclusivity } from "@faire/web--source/slate/icons/foundation/Exclusivity";
import { ShoppingBag } from "@faire/web--source/slate/icons/foundation/ShoppingBag";
import React from "react";
import { BrandReferralCreditDiscrepancyIA } from "../instantAnswers/referrals-brandReferralsCreditDiscrepancy";
import { BrandReferralEarnedCreditIA } from "../instantAnswers/referrals-brandReferralsEarnCredit";
import { BrandReferralHowDoReferralsWorkIA } from "../instantAnswers/referrals-brandReferralsHowDoReferralsWork";
import { BrandReferralStatusIA } from "../instantAnswers/referrals-brandReferralsStatus";
import { SettingRetailerExclusivityIsOn } from "../visibilityFunctions/settingRetailerExclusivityVisibilityFn";
import { useInsiderRetailerNodes } from "./useInsiderRetailerNodes";
export var useFaireProgramsRetailerNodes = function useFaireProgramsRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var insiders = useInsiderRetailerNodes(3);
  var articles = useArticles();
  return _objectSpread({
    FairePrograms: {
      id: "FairePrograms",
      label: strictLocalize({
        id: "PJGwJ9",
        defaultMessage: [{
          "type": 0,
          "value": "Programas de Faire"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Exclusivity, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["Exclusivity", "OpenWithFaire", "ReferABrand", "Insider"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "axx2hq",
        defaultMessage: [{
          "type": 0,
          "value": "Problema con los programas de Faire"
        }]
      })
    },
    Exclusivity: {
      id: "Exclusivity",
      label: strictLocalize({
        id: "NjU00Y",
        defaultMessage: [{
          "type": 0,
          "value": "Programa Exclusividad"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Exclusivity, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.Account.WHAT_IS_EXCLUSIVITY],
      isNodeVisible: SettingRetailerExclusivityIsOn,
      level: 2,
      sidebarTitle: strictLocalize({
        id: "Oc9nC3",
        defaultMessage: [{
          "type": 0,
          "value": "Problema con la exclusividad"
        }]
      })
    },
    OpenWithFaire: {
      id: "OpenWithFaire",
      label: strictLocalize({
        id: "jkKQPU",
        defaultMessage: [{
          "type": 0,
          "value": "Open with Faire"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(ShoppingBag, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      level: 1,
      articles: [articles.GettingStarted.OPEN_WITH_FAIRE],
      sidebarTitle: strictLocalize({
        id: "I3UMQ8",
        defaultMessage: [{
          "type": 0,
          "value": "Problema con Open with Faire"
        }]
      })
    },
    ReferABrand: {
      id: "ReferABrand",
      label: strictLocalize({
        id: "K7lkVd",
        defaultMessage: [{
          "type": 0,
          "value": "Invitar a una marca"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Email, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      level: 2,
      sidebarTitle: strictLocalize({
        id: "/77TqR",
        defaultMessage: [{
          "type": 0,
          "value": "Invitar a una marca"
        }]
      }),
      children: ["AboutBrandReferrals", "CheckReferralStatus", "EarnReferralCredit", "ReportCreditDiscrepancy"]
    },
    AboutBrandReferrals: {
      id: "AboutBrandReferrals",
      label: strictLocalize({
        id: "U3aL5j",
        defaultMessage: [{
          "type": 0,
          "value": "Acerca de las invitaciones a marcas"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE, articles.FAQ.BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS],
      instantAnswer: BrandReferralHowDoReferralsWorkIA(strictLocalize),
      level: 3
    },
    CheckReferralStatus: {
      id: "CheckReferralStatus",
      label: strictLocalize({
        id: "MOzD2p",
        defaultMessage: [{
          "type": 0,
          "value": "Comprobar el estado de una invitación"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralStatusIA(strictLocalize),
      level: 3
    },
    EarnReferralCredit: {
      id: "EarnReferralCredit",
      label: strictLocalize({
        id: "NAy0F4",
        defaultMessage: [{
          "type": 0,
          "value": "Conseguir bonos por invitaciones"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralEarnedCreditIA(strictLocalize),
      level: 3
    },
    ReportCreditDiscrepancy: {
      id: "ReportCreditDiscrepancy",
      label: strictLocalize({
        id: "JH6fbz",
        defaultMessage: [{
          "type": 0,
          "value": "Informar de una discrepancia en los bonos"
        }]
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralCreditDiscrepancyIA(strictLocalize),
      level: 3
    }
  }, insiders);
};